import base from './base';

export const tag = (value: any) => base(value);

export default tag;
